module.exports = __webpack_public_path__ + "static/img/10.65a564a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/10.png
// module id = 5sCt
// module chunks = 0